import { ALTERNATIVE, ALTERNATIVE_URL_PREFIX, BOND, BOND_URL_PREFIX, COMPANY, COMPANY_FUND, COMPANY_URL_PREFIX, CUSTOM_SECURITY, CUSTOM_SECURITY_ID_PREFIX, CUSTOM_SECURITY_URL_PREFIX, INDEX, INDEX_ID_PREFIX, INDEX_URL_PREFIX, INDICATOR, INDICATOR_ID_PREFIX, INDICATOR_URL_PREFIX, MODEL_PORTFOLIO, MODEL_PORTFOLIO_ID_PREFIX, MODEL_PORTFOLIO_URL_PREFIX, MUTUAL_FUND, MUTUAL_FUND_ID_PREFIX, MUTUAL_FUND_URL_PREFIX, REGISTRATION, REGISTRATIONS_URL_PREFIX, SEPARATE_ACCOUNT, SEPARATE_ACCOUNT_ID_PREFIX, SEPARATE_ACCOUNT_URL_PREFIX, } from 'NewAngular/constants/core.constants';
const securityTypesFromIdMap = {
    [CUSTOM_SECURITY_ID_PREFIX]: CUSTOM_SECURITY,
    [INDICATOR_ID_PREFIX]: INDICATOR,
    [MODEL_PORTFOLIO_ID_PREFIX]: MODEL_PORTFOLIO,
    [MUTUAL_FUND_ID_PREFIX]: MUTUAL_FUND,
    [SEPARATE_ACCOUNT_ID_PREFIX]: SEPARATE_ACCOUNT,
    test: 'aa',
};
export const getSecurityTypeFromId = (securityId) => {
    // do not return a type if empty string / undefined
    if (!securityId)
        return undefined;
    if (securityId[0] === INDEX_ID_PREFIX)
        return INDEX;
    const prefix = securityId.slice(0, 2);
    return securityTypesFromIdMap[prefix] ?? COMPANY;
};
const securityUrlPrefixesFromTypeMap = {
    [ALTERNATIVE]: ALTERNATIVE_URL_PREFIX,
    [BOND]: BOND_URL_PREFIX,
    [COMPANY]: COMPANY_URL_PREFIX,
    [CUSTOM_SECURITY]: CUSTOM_SECURITY_URL_PREFIX,
    [INDEX]: INDEX_URL_PREFIX,
    [INDICATOR]: INDICATOR_URL_PREFIX,
    [MODEL_PORTFOLIO]: MODEL_PORTFOLIO_URL_PREFIX,
    [MUTUAL_FUND]: MUTUAL_FUND_URL_PREFIX,
    [SEPARATE_ACCOUNT]: SEPARATE_ACCOUNT_URL_PREFIX,
    [REGISTRATION]: REGISTRATIONS_URL_PREFIX,
};
export const getSecurityUrlPrefixFromType = (securityType) => securityUrlPrefixesFromTypeMap[securityType] ?? '';
export const isSecurityType = (securityType, securityId) => getSecurityTypeFromId(securityId) === securityType;
const securityTypeToPluralLabelMap = {
    [ALTERNATIVE]: 'Alteratives',
    [BOND]: 'Bonds',
    [COMPANY]: 'Equities',
    [CUSTOM_SECURITY]: 'Custom Securities',
    [INDEX]: 'Indices',
    [INDICATOR]: 'Indicators',
    [MODEL_PORTFOLIO]: 'Model Portfolios',
    [MUTUAL_FUND]: 'Funds',
    [SEPARATE_ACCOUNT]: 'Separate Accounts',
    [REGISTRATION]: 'Registrations',
};
export const getPluralLabelFromType = (securityType) => securityTypeToPluralLabelMap[securityType] ?? '';
export const getHoldingsLayerUserPreferenceKey = (securityType) => {
    const securityTypeHoldingsLayerPreferenceMap = {
        [COMPANY]: 'company_fund_holdings_layer_selection',
        [COMPANY_FUND]: 'company_fund_holdings_layer_selection',
        [MODEL_PORTFOLIO]: 'model_portfolio_holdings_layer_selection',
        [MUTUAL_FUND]: 'mutual_fund_holdings_layer_selection',
    };
    return securityTypeHoldingsLayerPreferenceMap[securityType] ?? '';
};
export function getSecurityPageType() {
    const element = document.querySelector('[securityPageType]');
    return element?.attributes.getNamedItem('securityPageType').value || undefined;
}
